import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useTheme } from "@mui/material/styles";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import AddTaskIcon from "@mui/icons-material/AddTask";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PropTypes from "prop-types";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  Tooltip,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress,
  Autocomplete,
  InputAdornment,
  IconButton,
} from "@mui/material";
import MDBox from "components/MDBox";
import {
  ViewButton,
  DeleteButton,
  StyledTypography,
  StyledButton,
  StyledButtonC,
  StyledAlert,
  StyledSnackbar,
  StyledAgGridContainer,
  CustomTableCell,
  inputStyle,
} from "components/StyledComponents/styledComponents.js";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { entryStyles } from "components/Styles/loanEntryStyles";
import {
  selectScrollStyle,
  tableCellStyle,
  CustomPaper,
  tableShadow,
  autoSelectStyle2,
  useGlobalStyles,
} from "components/Styles/globalStyles";
import { voucherMasterStyles } from "components/Styles/voucherStyles";
import AddIcon from "@mui/icons-material/Add";
import { useAccountsApi } from "customApiHooks/accountsApi";
import { globalStyles } from "components/Styles/globalStyles";
import { useMaterialUIController } from "context";
import { CloudUpload, Download as DownloadIcon } from "@mui/icons-material";
import Cookie from "js-cookie";
import { StyledTypographyA } from "components/StyledComponents/styledComponents.js";

export default function JournalVoucher() {
  const [controller, dispatch] = useMaterialUIController();
  const { user } = controller;
  const [selectedData, setSelectedData] = useState();
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedAccountName, setSelectedAccountName] = useState("");
  const [selectedNarration, setNarration] = useState("");
  const [voucherNo, setVoucherNo] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [voucherToDelete, setVoucherToDelete] = useState(null);
  const [companyIdToDelete, setCompanyIdToDelete] = useState(null);
  const [SelectCompany, setSelectCompany] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [Company, SelectedCompany] = useState("");
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 2).toISOString().split("T")[0];
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 1)
    .toISOString()
    .split("T")[0];
  const [fromDate, setFromDate] = useState(firstDay);
  const [toDate, setToDate] = useState(lastDay);
  const [seachTypeForGet, setSeachTypeForGet] = useState("JRV");
  const [openFileFolder, setOpenFileFolder] = useState(false);
  const [file, setFile] = useState(null);
  const [paramsData, setParamsData] = useState({});
  const jwt_token = Cookie.get("jwt_token");
  const theme = useTheme();
  const MInput = inputStyle();
  const [rows, setRows] = useState([{ particular: "", amount: "" }]);
  const [totalAmount, setTotalAmount] = useState(0);
  const resetForm = () => {
    setSelectedAccount("");
    setVoucherNo("");
    setSelectedAccountName("");
    setNarration("");
    setSelectCompany("");
    setSelectedDate(new Date().toISOString().split("T")[0]);
    setRows([{ particular: "", amount: "" }]);
    setTotalAmount(0);
  };
  const resetFormState = () => {
    resetForm();
    setIsEditMode(false);
  };
  const {
    companies,
    accounts,
    paymentAccounts,
    tableData,
    voucherData,
    isEditMode,
    open,
    message,
    alertType,
    setOpen,
    getVoucherApi,
    manageVouchersApi,
    fetchListOfVouchers,
    handleDeleteVoucher,
    setIsEditMode,
    loading,
    showAlert,
    setLoading,
    handleCloseAlert,
  } = useAccountsApi(resetFormState);
  useEffect(() => {
    const compId = user.companyId;
    const payload = {
      companyId: Company || compId,
      fromDate: fromDate || "2024-10-01",
      toDate: toDate || "2024-10-25",
      searchType: "JRV",
    };
    fetchListOfVouchers(payload);
  }, []);
  const ActionCellRenderer = (props) => {
    const rowIndex = props.node.rowIndex;
    let rowData = null;
    if (props.api && props.api.getDisplayedRowAtIndex(rowIndex)) {
      rowData = props.api.getDisplayedRowAtIndex(rowIndex).data;
    } else {
      console.error("API or row data is not available.");
    }
    const handleEdit = () => {
      handleEditVoucher(rowData.voucherID, rowData.companyId);
    };

    ActionCellRenderer.propTypes = {
      data: PropTypes.shape({
        voucherID: PropTypes.number.isRequired,
        Date: PropTypes.string.isRequired,
        VoucherNo: PropTypes.string.isRequired,
        Particulars: PropTypes.string,
        Amount: PropTypes.number.isRequired,
      }).isRequired,
    };

    return (
      <div>
        <ViewButton type="button" onClick={handleEdit}>
          <EditIcon />
        </ViewButton>
        <DeleteButton
          type="button"
          onClick={() => {
            setVoucherToDelete(rowData.voucherID);
            setCompanyIdToDelete(rowData.companyId);
            setOpenDialog(true);
          }}
        >
          <DeleteIcon />
        </DeleteButton>
        <Tooltip title="Upload" arrow>
          <IconButton onClick={() => handleOpenDialogFileUploader(rowData)} color="primary">
            <CloudUpload />
          </IconButton>
        </Tooltip>
        <Tooltip title="Download" arrow>
          <IconButton onClick={() => triggerS3File(rowData)} color="primary">
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      </div>
    );
  };
  const columnDefs = [
    { headerName: "Actions", cellRenderer: ActionCellRenderer, minWidth: 100, flex: 1 },
    {
      headerName: "Date",
      field: "Date",
      filter: true,
      sorted: true,
      minWidth: 140,
      flex: 1,
      valueFormatter: (params) => {
        if (!params.value) return ""; // Handle null/undefined values
        const date = new Date(params.value);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      headerName: "Voucher No",
      field: "VoucherNo",
      filter: true,
      sorted: true,
      minWidth: 80,
      flex: 1,
      cellRenderer: (params) => {
        return <span>{params.value || "No Vouchers"}</span>;
      },
    },
    {
      headerName: "Particulars",
      field: "Particulars",
      minWidth: 110,
      flex: 1,
      filter: true,
      sorted: true,
      cellRenderer: (params) => {
        return <span>{params.value || "No Particulars"}</span>;
      },
    },
    {
      headerName: "Amount",
      field: "Amount",
      filter: true,
      sorted: true,
      minWidth: 120,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" }, // Aligns the text to the right
      valueFormatter: (params) =>
        `₹ ${params.value.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
    },
  ];
  const handleRowChange = (index, field, value) => {
    let updatedValue = value;
    // If the field is "amount", ensure only numeric input
    if (field === "amount") {
      // Remove any non-numeric characters except "."
      updatedValue = value.replace(/[^0-9.]/g, "");
    }
    // Update the rows with the new value
    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, [field]: updatedValue } : row
    );
    // Check for duplicates if the field being changed is `particular`
    if (field === "particular") {
      const accountIDs = updatedRows.map((row) => row.particular);
      const uniqueAccountIDs = new Set(accountIDs);
      if (uniqueAccountIDs.size !== accountIDs.length) {
        showAlert("Account name should be unique", "error"); // Show alert dialog
        return; // Prevent updating the rows if a duplicate is found
      }
    }
    setRows(updatedRows);
    // Recalculate the total on amount change
    if (field === "amount") calculateTotal(updatedRows);
  };
  // const formattedAmount = amount;

  const calculateTotal = (updatedRows) => {
    let byTotal = 0;
    let toTotal = 0;

    updatedRows.forEach((row) => {
      const amount = Number(row.amount || 0);
      if (row.byToOption === "BY") {
        byTotal += amount;
      } else if (row.byToOption === "TO") {
        toTotal += amount;
      }
    });

    const netTotal = byTotal - toTotal;

    setTotalAmount(netTotal);
  };

  useEffect(() => {
    const selected = accounts.find((item) => item.accountID === selectedAccount);
    setSelectedAccountName(selected ? selected.accountName : "");
  }, [selectedAccount]);
  const handleEditVoucher = async (vid, cid) => {
    try {
      setIsEditMode(true);

      const payload = {
        voucherID: vid,
        companyID: cid,
      };

      const data = await getVoucherApi(payload);

      if (data) {
        setSelectedData(data);
        setSelectCompany(data.companyID);
        setVoucherNo(data.voucherClientID);
        setSelectedDate(data.entryDate?.split("T")[0] || "");
        setNarration(data.narration || "");

        const debitRows = (data.debitItems || []).map((item) => ({
          byToOption: "BY",
          particular: item.accountID,
          amount: item.amount,
        }));

        const creditRows = (data.creditItems || []).map((item) => ({
          byToOption: "TO",
          particular: item.accountID,
          amount: item.amount,
        }));

        setRows([...debitRows, ...creditRows]);
        calculateTotal([...debitRows, ...creditRows]);

        // Print on edit
        if (data.PrintFormat) {
          const newWindow = window.open("", "_blank");
          newWindow.document.open();
          newWindow.document.write(data.PrintFormat);
          newWindow.document.close();
        }
      }
    } catch (error) {
      showAlert("Error in handleEditVoucher:", "error");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleSave = () => {
    const duplicateAccountFound = rows.some((row) => row.particular === selectedAccount);
    if (duplicateAccountFound) {
      showAlert("Accounts should be unique", "error");
      return; // Stop further execution if duplicate accounts are found
    }
    // Calculate the total amount for debit items
    const creditTotal = totalAmount;

    // Check if debit total equals the credit total
    if (totalAmount !== creditTotal) {
      showAlert("Error: Debit and Credit totals must be equal.", "error");
      return;
    }

    if (isEditMode) {
      fetchSaveVoucher("UPDATE", selectedData.voucherID);
    } else {
      fetchSaveVoucher("ADD");
    }
  };
  const fetchSaveVoucher = async (action = "ADD", voucherID = "0") => {
    const requestType = action.toUpperCase();
    const payload = {
      companyID: user.companyId,
      RequestType: requestType,
      voucherID,
      VoucherClientID: voucherNo,
      VoucherType: "JRV", // Voucher type for JournalVoucher
      yearNo: 1,
      entryDate: selectedDate,
      paymentMode: "", // Leave empty for JournalVoucher
      paymentReference: "",
      narration: selectedNarration,
      CreateUserID: "ADMINL1",
      DebitItems: rows
        .filter((row) => row.byToOption === "BY")
        .map((row) => ({
          AccountType: "DR",
          AccountID: row.particular,
          Amount: row.amount,
        })),
      CreditItems: rows
        .filter((row) => row.byToOption === "TO")
        .map((row) => ({
          AccountType: "CR",
          AccountID: row.particular,
          Amount: row.amount,
        })),
    };

    const response = await manageVouchersApi(payload, fromDate, toDate, Company, seachTypeForGet);

    // If the API response contains PrintFormat, open it in a new tab
    if (response?.PrintFormat) {
      const newWindow = window.open("", "_blank");
      newWindow.document.open();
      newWindow.document.write(response.PrintFormat);
      newWindow.document.close();
    }
  };

  const handleAddItem = (event) => {
    setRows((prevRows) => [...prevRows, { particular: "", amount: "" }]);
  };
  const handleRemoveItem = (index) => {
    setRows((prevRows) => {
      const updatedRows = prevRows.filter((_, i) => i !== index);
      const finalRows = updatedRows.length ? updatedRows : [{ particular: "", amount: "" }];
      calculateTotal(finalRows); // Call calculateTotal with the updated rows
      return finalRows;
    });
  };
  const fetchVoucherData = async () => {
    const payload = {
      companyId: user.companyId,
      fromDate: fromDate || "2024-10-01",
      toDate: toDate || "2024-10-25",
      searchType: "JRV",
    };
    fetchListOfVouchers(payload);
  };

  const handleOpenDialogFileUploader = (params) => {
    setParamsData(params);
    setOpenFileFolder(true);
  };

  const handleCloseDialogFileUploader = () => {
    setOpenFileFolder(false);
    setFile(null);
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const triggerS3File = async (params) => {
    const url = `https://s3service.sconexsoft.com/s3bucket/presigned-url?fileName=${params.VoucherNo}&bucketName=fintrackaccountsprod&operation=download`;

    try {
      console.log("Getting Pre-signed URL:", url);

      const downloadResponse = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!downloadResponse.ok) {
        throw new Error(`Failed to get Pre-signed URL: ${downloadResponse.statusText}`);
      }

      const presignedUrl = await downloadResponse.text();

      console.log("Pre-signed URL received:", presignedUrl);

      if (!presignedUrl.startsWith("http")) {
        throw new Error("Invalid Pre-Signed URL received");
      }
      if (presignedUrl) {
        window.open(presignedUrl, "_blank", "noopener,noreferrer");
        return;
      }
    } catch (error) {
      console.error("Download Error:", error);
      showAlert("Failed to Download", "error");
    }
  };

  const uploadFileToS3 = async () => {
    console.log("File to upload:", file);
    if (!file) {
      showAlert("Please select a image first.", "error");
      return;
    } else {
      if (!file.name.toLowerCase().endsWith(".jpg")) {
        showAlert("Only .jpg images are allowed!", "error");
        return;
      }
    }
    const uploadUrl = `https://s3service.sconexsoft.com/s3bucket/presigned-url?fileName=${paramsData.VoucherNo}&bucketName=fintrackaccountsprod&operation=upload`;
    setLoading(true);
    try {
      const response = await fetch(uploadUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to get pre-signed URL");

      const presignedUrl = await response.text();

      if (!presignedUrl.startsWith("http")) {
        throw new Error("Invalid Pre-Signed URL received");
      }
      const uploadResponse = await fetch(presignedUrl, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": "image/jpeg",
        },
      });

      if (uploadResponse.ok) {
        showAlert("File uploaded successfully!", "success");
        setOpenFileFolder(false);
      } else {
        const errorText = await uploadResponse.text();
        throw new Error(`Upload failed: ${uploadResponse.statusText}, Details: ${errorText}`);
      }
    } catch (error) {
      console.error("Upload Error:", error);
      showAlert("File upload failed.", "error");
    }
    setLoading(false);
  };

  return (
    <DashboardLayout>
      <Dialog open={openFileFolder} onClose={handleCloseDialogFileUploader}>
        <StyledTypographyA mt={2}>Upload File</StyledTypographyA>
        <DialogContent>
          <TextField
            sx={MInput.b}
            InputLabelProps={{
              sx: {
                color: MInput.a,
              },
            }}
            type="file"
            onChange={handleFileChange}
          />
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={handleCloseDialogFileUploader} color="secondary">
            Cancel
          </StyledButton>
          <StyledButton onClick={uploadFileToS3} color="primary" variant="contained">
            Submit
          </StyledButton>
        </DialogActions>
      </Dialog>
      <TableContainer component={Paper} sx={globalStyles.mainTable}>
        <Grid container spacing={2} mt={0}>
          <Grid item xs={12} md={7}>
            <TableContainer
              sx={{ ...tableShadow, ...voucherMasterStyles.paymentVoucher }}
              component={Paper}
              mt={1}
              pb={2}
            >
              <div style={entryStyles.divStyle}>
                <StyledTypography>
                  {!isEditMode ? "Create Journal Voucher" : "Edit Voucher Details"}
                </StyledTypography>
                {isEditMode && (
                  <Tooltip title="Reset">
                    <StyledButtonC onClick={resetFormState}>
                      <RestartAltIcon />
                    </StyledButtonC>
                  </Tooltip>
                )}
              </div>
              <StyledSnackbar
                open={open}
                autoHideDuration={5000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                severity={alertType}
              >
                <StyledAlert onClose={handleClose} severity={alertType}>
                  {message}
                </StyledAlert>
              </StyledSnackbar>
              <Dialog
                onClose={() => setLoading(false)}
                open={loading}
                aria-labelledby="loading-dialog-title"
              >
                <DialogContent
                  style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
                >
                  <CircularProgress color="primary" />
                  <Typography variant="h6" style={{ marginTop: "20px" }}>
                    Loading, please wait...
                  </Typography>
                </DialogContent>
              </Dialog>
              <form autoComplete="off">
                <MDBox pt={3} pb={3} px={3}>
                  <Grid container spacing={2}>
                    <Grid item xs={6} md={2.5}>
                      <TextField
                        fullWidth
                        label="Date"
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        sx={MInput.b}
                        InputLabelProps={{
                          sx: {
                            color: MInput.a,
                          },
                        }}
                      />
                    </Grid>
                    {isEditMode && (
                      <Grid item xs={4}>
                        <TextField
                          label="Voucher No"
                          value={voucherNo}
                          InputProps={{
                            readOnly: true,
                          }}
                          fullWidth
                          sx={MInput.b}
                          InputLabelProps={{
                            sx: {
                              color: MInput.a,
                            },
                          }}
                        />
                      </Grid>
                    )}
                  </Grid>
                </MDBox>
                <TableContainer
                  component={Paper}
                  sx={voucherMasterStyles.tableContainerShadowStyle}
                >
                  <Table>
                    <TableBody>
                      <TableRow sx={voucherMasterStyles.tableHead}>
                        <CustomTableCell
                          sx={{ minWidth: "70px", width: "100px" }}
                          fontWeight="bold"
                          align="center"
                        >
                          By / To
                        </CustomTableCell>
                        <CustomTableCell
                          sx={{ flex: 1, minWidth: "200px", maxWidth: "400px" }}
                          fontWeight="bold"
                          align="center"
                        >
                          Particulars
                        </CustomTableCell>
                        <CustomTableCell
                          sx={{ minWidth: "150px", width: "200px" }}
                          fontWeight="bold"
                          align="center"
                        >
                          Amount
                        </CustomTableCell>
                        <CustomTableCell
                          sx={{ minWidth: "100px", width: "150px" }}
                          fontWeight="bold"
                          align="center"
                        >
                          Add / Remove
                        </CustomTableCell>
                      </TableRow>
                      {rows.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell align="center">
                            <Grid item xs={12}>
                              <Autocomplete
                                options={["BY", "TO"]}
                                value={row.byToOption || ""}
                                onChange={(event, newValue) =>
                                  handleRowChange(index, "byToOption", newValue)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label=""
                                    variant="outlined"
                                    fullWidth
                                    sx={{
                                      height: 43,
                                      ...MInput.b,
                                      "& .MuiInputBase-root": {
                                        height: "100%",
                                        minHeight: 43,
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: MInput.a, // Ensure this applies to the label
                                        "&.Mui-focused": {
                                          color: "red", // Focused label color
                                        },
                                      },
                                    }}
                                  />
                                )}
                              />
                            </Grid>
                          </TableCell>
                          <TableCell align="center">
                            <Grid item xs={12}>
                              <Autocomplete
                                options={paymentAccounts}
                                getOptionLabel={(option) => option.accountName}
                                value={
                                  paymentAccounts.find(
                                    (item) => item.accountID === row.particular
                                  ) || null
                                }
                                onChange={(event, value) =>
                                  handleRowChange(index, "particular", value ? value.accountID : "")
                                }
                                mt={10}
                                disableClearable={false}
                                filterOptions={(options, state) => {
                                  const input = state.inputValue.toLowerCase();

                                  // Filter options that start with the input value
                                  const startsWithInput = options.filter((option) =>
                                    option.accountName.toLowerCase().startsWith(input)
                                  );

                                  // Filter options that contain the input value but do not start with it
                                  const containsInput = options.filter(
                                    (option) =>
                                      !option.accountName.toLowerCase().startsWith(input) &&
                                      option.accountName.toLowerCase().includes(input)
                                  );

                                  // Combine the options: starts with input first, then the rest
                                  return [...startsWithInput, ...containsInput];
                                }}
                                PaperComponent={CustomPaper}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Select Account"
                                    variant="outlined"
                                    sx={{
                                      height: 43,
                                      ...MInput.b,
                                      ...voucherMasterStyles.selectClass,
                                      "& .MuiInputBase-root": {
                                        height: "100%",
                                        minHeight: 43,
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: MInput.a, // Ensure this applies to the label
                                        "&.Mui-focused": {
                                          color: "red", // Focused label color
                                        },
                                      },
                                    }}
                                  />
                                )}
                              />
                            </Grid>
                          </TableCell>
                          <TableCell align="center">
                            <Grid item xs={12}>
                              <TextField
                                fullWidth
                                label=""
                                value={row.amount}
                                onChange={(e) => handleRowChange(index, "amount", e.target.value)}
                                sx={{ ...MInput.b, ...voucherMasterStyles.amountFeild }}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">₹</InputAdornment>
                                  ),
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a,
                                  },
                                }}
                              />
                            </Grid>
                          </TableCell>
                          <TableCell align="center" sx={{ minWidth: "100px", width: "120px" }}>
                            <ViewButton type="button" onClick={handleAddItem}>
                              <AddIcon />
                            </ViewButton>
                            <DeleteButton type="button" onClick={() => handleRemoveItem(index)}>
                              <DeleteIcon />
                            </DeleteButton>
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow>
                        <CustomTableCell
                          minWidth="100px"
                          flexGrow={1}
                          fontWeight="bold"
                          align="right"
                          colSpan={2}
                        >
                          Total Amount
                        </CustomTableCell>
                        <CustomTableCell
                          minWidth="80px"
                          flexGrow={1}
                          fontWeight="bold"
                          align="center"
                          colSpan={2}
                        >
                          <strong>
                            {`₹ ${totalAmount.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`}
                          </strong>
                        </CustomTableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <Grid item xs={12} mt={2} p={2} md={12}>
                  <TextField
                    label="Narration"
                    fullWidth
                    multiline
                    rows={2}
                    value={selectedNarration}
                    onChange={(e) => setNarration(e.target.value)}
                    sx={MInput.b}
                    InputLabelProps={{
                      sx: {
                        color: MInput.a,
                      },
                    }}
                  />
                </Grid>
                <MDBox pt={2} px={1} pr={4}>
                  <Grid container justifyContent="flex-end">
                    <StyledButton type="button" onClick={() => handleSave()}>
                      {isEditMode ? "Update" : "Save"}
                    </StyledButton>
                  </Grid>
                </MDBox>
              </form>
            </TableContainer>
          </Grid>
          <Grid item xs={12} md={5}>
            <TableContainer
              component={Paper}
              sx={{
                ...voucherMasterStyles.tableContainertwoStyle,
              }}
            >
              {/* Form Section */}
              <MDBox sx={voucherMasterStyles.mdBoxStyle}>
                <MDBox mt={1} mb={2} sx={voucherMasterStyles.subMdBoxStyle}>
                  <TextField
                    label="From Date"
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    sx={{ ...voucherMasterStyles.textFieldClass, ...MInput.b }}
                    InputLabelProps={{
                      sx: { color: MInput.a },
                    }}
                  />
                  <TextField
                    label="To Date"
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    InputLabelProps={{
                      sx: { color: MInput.a },
                    }}
                    sx={{ ...voucherMasterStyles.textFieldClass, ...MInput.b }}
                  />
                  <StyledButton
                    type="button"
                    onClick={fetchVoucherData}
                    sx={voucherMasterStyles.buttonFieldClass}
                  >
                    Display
                  </StyledButton>
                </MDBox>
              </MDBox>

              {/* AgGrid Section */}
              <StyledAgGridContainer
                component={Paper}
                sx={{
                  ...voucherMasterStyles.agGridStyle,
                  flexGrow: 1, // Take up remaining space
                }}
                className={`ag-theme-alpine`}
              >
                <AgGridReact
                  rowData={tableData}
                  columnDefs={columnDefs}
                  pagination={true}
                  paginationPageSize={10}
                />
              </StyledAgGridContainer>
            </TableContainer>
          </Grid>
          <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
            <DialogContent>
              <Typography>Are you sure you want to delete this voucher?</Typography>
            </DialogContent>
            <DialogActions>
              <StyledButton
                onClick={() => {
                  if (voucherToDelete) {
                    handleDeleteVoucher(
                      voucherToDelete,
                      companyIdToDelete,
                      fromDate,
                      toDate,
                      Company
                    );
                  }
                  setOpenDialog(false); // Close the dialog after deleting
                }}
              >
                Yes
              </StyledButton>
              <StyledButton onClick={() => setOpenDialog(false)}>No</StyledButton>
            </DialogActions>
          </Dialog>
        </Grid>
      </TableContainer>
    </DashboardLayout>
  );
}
JournalVoucher.propTypes = {
  node: PropTypes.shape({
    rowIndex: PropTypes.number.isRequired,
  }).isRequired,
  api: PropTypes.shape({
    getDisplayedRowAtIndex: PropTypes.func.isRequired,
  }).isRequired,
};
